import { Analytics } from './analytics';

export class EmailShareTracking {
   
   public static trackEmailSharing() {

      let emailLink = $('a[href^="mailto:"].data-social-media-email');

      emailLink.click((e) => {
         Analytics.sendRawEvent({
            "event": "share_content"
         })
      });   
   }
}